import React, { useEffect, useState } from "react";
import { getOwnUser } from "../api/user";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createApplicant,
  getVerificationToken,
} from "../api/verification";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

// Report a failure both to the native app (via the WebView bridge) and to the
// on-screen UI, so the flow never hangs silently on "Verifizierung startet...".
const report = (stage, error) => {
  const message =
    error?.response?.data?.message ||
    error?.message ||
    (typeof error === "string" ? error : "Unbekannter Fehler");
  // eslint-disable-next-line no-console
  console.error(`[verify] ${stage}:`, message, error);
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: "error", stage, message })
    );
  }
  return message;
};

export default () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const fail = (stage, error) => {
    setLoading(false);
    setErrorMessage(report(stage, error));
  };

  const { data: user, refetch, isSuccess, isError, error } = useQuery(
    ["ownUser"],
    () => getOwnUser(),
    { enabled: false, retry: false }
  );

  useEffect(() => {
    if (!window.data || !window.data.token) {
      fail("token", "Kein Token von der App erhalten (window.data.token fehlt).");
      return;
    }
    localStorage.setItem("token", window.data.token);
    setToken(window.data.token);
  }, []);

  useEffect(() => {
    if (!token) return;
    refetch();
  }, [token]);

  useEffect(() => {
    if (isError) {
      fail("getOwnUser", error);
      return;
    }
    if (!isSuccess) return;
    if (!user) {
      fail("getOwnUser", "Benutzer konnte nicht geladen werden (evtl. ungültiges Token / 401).");
      return;
    }
    if (!user.firstName) {
      fail("profile", "Profil unvollständig (kein Vorname).");
      return;
    }
    startVerification(user);
  }, [isSuccess, isError]);

  const { mutate: _createApplicant } = useMutation(
    (_user) => createApplicant(),
    {
      onSuccess: (_applicant) => {
        if (!_applicant) {
          fail("createApplicant", "Leere Antwort vom Server.");
          return;
        }
        if (_applicant.verificationBlocked) {
          setLoading(false);
          alert("Ihre Verifikation ist 3 mal fehlgeschlagen. Eine erneute Verifikation können wir nur gegen eine Gebühr selber durchführen.");
          return;
        }
        if (!_applicant.id) {
          fail("createApplicant", "Keine Applicant-ID erhalten.");
          return;
        }
        _getVerificationToken(_applicant.id);
      },
      onError: (e) => fail("createApplicant", e),
    }
  );

  const { mutate: _getVerificationToken } = useMutation(
    (id) => getVerificationToken(id),
    {
      onSuccess: (data, variables) => {
        try {
          const sdkToken = JSON.parse(data).token;
          setLoading(false);
          navigate("/verification", {
            state: { token: sdkToken, applicantId: variables },
          });
        } catch (e) {
          fail("sdkToken", e);
        }
      },
      onError: (e) => fail("getVerificationToken", e),
    }
  );

  const startVerification = (user) => {
    _createApplicant(user);
  };

  return (
    <div>
      <center>
        <h3>Verifizierung startet...</h3>
        {loading && <Spinner animation="grow" />}
        {errorMessage && (
          <p style={{ color: "#c0392b", marginTop: 16, padding: "0 16px" }}>
            {errorMessage}
          </p>
        )}
      </center>
    </div>
  );
};
